import { createContext, useContext } from "react"

import PropTypes from "prop-types"

// Create package context
const PackageContext = createContext()
PackageContext.displayName = "PackageContext"

// Package provider
function PackageControllerProvider({ children }) {
  const value = 0
  return <PackageContext.Provider value={value}>{children}</PackageContext.Provider>
}

// Use package context
function usePackageController() {
  const context = useContext(PackageContext)
  //   if (!context) throw new Error("PackageContextController should be used inside PackageControllerProvider")
  return context
}

// Typechecking PackageControllerProvider props
PackageControllerProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export { PackageControllerProvider, usePackageController }
